exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".screen-full{position:fixed;height:22px;bottom:10px;right:30px;text-align:right}.screen-full .screen-full-btn{cursor:pointer;display:inline-block;width:22px;height:22px;line-height:22px;font-size:24px;color:#666}", ""]);

// exports
